import { Component, inject } from '@angular/core';
import { TransactionStore } from '@app/transaction/store/transaction.store';
import { ButtonAppearance } from '@ui/button';
import { UiContext } from '@ui/ui.enums';

@Component({
    selector: 'smvd-app-water-transfer-card',
    template: `
        <app-dashboard-card
            [first]="true"
            [title]="'DASHBOARD.UTILITY_TRANSFER.WATER.TITLE' | translate"
            [text]="transactionStore.transaction()?.address | formatAddress"
            [hasBorderBottom]="true"
            imageName="smooved-water.png"
            [last]="true"
        >
            <ng-container up-to-and-including-phone-landscape>
                <div class="u-flex-column u-flex-align-items-stretch">
                    <ng-container
                        [ngTemplateOutlet]="actions"
                        [ngTemplateOutletContext]="{ class: 'u-margin-bottom-half u-text-align-center' }"
                    ></ng-container>
                </div>
            </ng-container>
            <ng-container tablet-portrait-up>
                <div class="u-flex-row u-flex-align-items-center">
                    <ng-container [ngTemplateOutlet]="actions" [ngTemplateOutletContext]="{ class: 'u-margin-right' }"></ng-container>
                </div>
            </ng-container>
        </app-dashboard-card>

        <ng-template #actions let-class="class">
            <a smvd-ui-button [context]="context.PrimaryDark" [appearance]="appearance.Stroked" [class]="class" [href]="waterTransferUri">
                {{ 'DASHBOARD.UTILITY_TRANSFER.WATER.CTA' | translate }}
            </a>
        </ng-template>
    `,
})
export class WaterTransferCardComponent {
    public readonly transactionStore = inject(TransactionStore);
    public readonly appearance = ButtonAppearance;
    public readonly context = UiContext;

    public waterTransferUri = '/water-transfer';
}
